// 가방 창 「세트」 탭 DOM(2026-10-27, 그래픽 위주). 값은 setPanelModel.ts(순수)가 만들고 여기서는 그리기만 한다.
// 맨 위: 지금 장착 중인 세트 그림 칸(부위 수·발동). 아래: 8세트 카드 — 4부위 그림 칸(장착 금테+체크 / 가진 것 밝게 / 없는 것 실루엣),
// 2·4세트 효과 한 줄씩(발동 중이면 초록), 얻는 곳 작은 배지. 글은 최소로 두고 그림이 먼저 보이게 한다.
// RpgUi가 값이 바뀔 때만 다시 그린다(프레임 루프에서 부르지 않는다).
import type { GameView } from '../shared/types';
import { FONT, FONT_NUM, el } from './dom';
import { assetUrl } from '../pwa/assetMap';
import { BADGE_SET } from './itemIcons';
import { SLOT_KO } from './gearModel';
import { gearImg } from './gearPanel';
import { setPanelModel, type SetCardView, type SetPieceView } from './setPanelModel';

/** 탭 아이콘: 겹친 방패 넷(세트 4부위) */
export const SET_TAB_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 2 2 3.6v3.2C2 9.6 3.7 11.6 6 12.4c2.3-.8 4-2.8 4-5.6V3.6zm12 0-4 1.6v3.2c0 2.8 1.7 4.8 4 5.6 2.3-.8 4-2.8 4-5.6V3.6zM6 12.6 2 14.2v3.2C2 20.2 3.7 22.2 6 23c2.3-.8 4-2.8 4-5.6v-3.2zm12 0-4 1.6v3.2c0 2.8 1.7 4.8 4 5.6 2.3-.8 4-2.8 4-5.6v-3.2z"/></svg>';

const STYLE_ID = 'dh-set-style';
const GOLD = '#f2c14e', GREEN = '#3fd07a';
const CSS =
  '.dh-set{display:flex;flex-direction:column;gap:10px;font-family:' + FONT + ';color:#eef2ff}' +
  // 맨 위 착용 세트 줄
  '.dh-set-top{display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:12px;border:1.5px solid rgba(242,193,78,.45);' +
  'background:linear-gradient(180deg,rgba(28,38,72,.92),rgba(12,17,36,.92));box-shadow:inset 0 0 0 1px rgba(10,14,30,.9)}' +
  '.dh-set-top .cnt{flex:0 0 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:56px;height:56px;border-radius:10px;' +
  'background:radial-gradient(circle at 50% 40%,rgba(63,208,122,.35),rgba(8,12,26,.9) 70%);border:2px solid ' + GREEN + ';color:#fff}' +
  '.dh-set-top .cnt b{font:900 26px ' + FONT_NUM + ';line-height:1}.dh-set-top .cnt small{font:800 10px ' + FONT + ';color:#bdf5d2}' +
  '.dh-set-top .cnt.off{border-color:rgba(174,185,218,.4);background:rgba(8,12,26,.7)}.dh-set-top .cnt.off b{color:#7d86a8}' +
  '.dh-set-worn{display:flex;gap:6px;flex-wrap:wrap;min-width:0;align-items:center}' +
  '.dh-set-chip{position:relative;width:48px;height:48px;border-radius:9px;border:2px solid rgba(63,208,122,.55);background:radial-gradient(circle at 50% 40%,#1f3a34,#0d1424 72%)}' +
  '.dh-set-chip.on{border-color:' + GREEN + ';box-shadow:0 0 10px rgba(63,208,122,.6)}' +
  '.dh-set-chip img{position:absolute;inset:6%;width:88%;height:88%;object-fit:contain;filter:drop-shadow(0 2px 2px rgba(0,0,0,.7))}' +
  '.dh-set-chip i{position:absolute;right:-4px;bottom:-5px;padding:0 4px;border-radius:6px;background:#0b1022;border:1px solid ' + GREEN + ';font:900 11px ' + FONT_NUM + ';font-style:normal;color:#bdf5d2}' +
  '.dh-set-none{font:700 12px ' + FONT + ';color:#9aa6c8}' +
  // 세트 카드 격자
  '.dh-set-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:8px}' +
  '.dh-set-card{position:relative;display:flex;flex-direction:column;gap:6px;padding:8px 9px 9px;border-radius:12px;border:1.5px solid rgba(242,193,78,.4);' +
  'background:linear-gradient(180deg,rgba(26,35,66,.95),rgba(11,15,32,.95));box-shadow:inset 0 0 0 1px rgba(8,10,22,.9)}' +
  '.dh-set-card.on2{border-color:' + GREEN + ';box-shadow:0 0 12px rgba(63,208,122,.28),inset 0 0 0 1px rgba(8,10,22,.9)}' +
  '.dh-set-card.on4{border-color:#9dffc2;box-shadow:0 0 16px rgba(63,208,122,.5),inset 0 0 0 1px rgba(8,10,22,.9)}' +
  '.dh-set-hd{display:flex;align-items:center;gap:6px;min-width:0}' +
  '.dh-set-hd img{width:22px;height:22px;flex:0 0 auto;object-fit:contain}' +
  '.dh-set-hd b{flex:1 1 auto;min-width:0;font:900 14px ' + FONT + ';color:#ffe7a0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
  '.dh-set-hd em{flex:0 0 auto;font:900 13px ' + FONT_NUM + ';font-style:normal;color:#aeb9da}.dh-set-card.on2 .dh-set-hd em{color:#7dffa0}' +
  '.dh-set-pcs{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:5px}' +
  '.dh-set-pc{position:relative;aspect-ratio:1;min-width:0;padding:0;border-radius:9px;border:2px solid rgba(63,208,122,.5);' +
  'background:radial-gradient(circle at 50% 38%,#20403a 0%,#121a33 62%,#0b1022 100%);box-shadow:inset 0 0 10px rgba(0,0,0,.55);overflow:hidden;cursor:pointer}' +
  '.dh-set-pc img{position:absolute;inset:7%;width:86%;height:86%;object-fit:contain;filter:drop-shadow(0 2px 3px rgba(0,0,0,.6));pointer-events:none}' +
  '.dh-set-pc.missing{cursor:default;border-style:dashed;border-color:rgba(174,185,218,.3);background:rgba(10,14,28,.8)}' +
  // 없는 부위: 검은 실루엣(윤곽만 보이게 옅은 빛)
  '.dh-set-pc.missing img{filter:brightness(0) drop-shadow(0 0 1px rgba(160,175,215,.55));opacity:.55}' +
  '.dh-set-pc.equipped{border-color:' + GOLD + ';box-shadow:0 0 0 1px #ffe7a0,0 0 10px rgba(242,193,78,.5),inset 0 0 10px rgba(0,0,0,.5)}' +
  '.dh-set-pc .ck{position:absolute;right:2px;top:2px;width:17px;height:17px;border-radius:50%;background:' + GOLD + ';color:#1a1206;display:grid;place-items:center;font:900 12px ' + FONT + ';line-height:1;box-shadow:0 1px 2px #000}' +
  '.dh-set-pc .nm{position:absolute;left:0;right:0;bottom:1px;text-align:center;font:800 9.5px ' + FONT + ';color:#cfd8f5;text-shadow:0 1px 2px #000,0 0 3px #000;pointer-events:none}' +
  '.dh-set-pc.missing .nm{color:#7d86a8}' +
  '.dh-set-fx{display:flex;flex-direction:column;gap:3px}' +
  '.dh-set-fx div{display:flex;align-items:center;gap:6px;min-width:0;font:700 12px ' + FONT + ';color:#7d86a8}' +
  '.dh-set-fx div span{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
  '.dh-set-fx i{flex:0 0 auto;display:grid;place-items:center;width:20px;height:20px;border-radius:50%;border:1.5px solid #4a5578;font:900 11px ' + FONT_NUM + ';font-style:normal;color:#7d86a8}' +
  '.dh-set-fx div.on{color:#7dffa0;font-weight:900}.dh-set-fx div.on i{border-color:' + GREEN + ';background:' + GREEN + ';color:#06210f}' +
  '.dh-set-src{display:flex;gap:4px;flex-wrap:wrap}' +
  '.dh-set-src span{padding:1px 7px;border-radius:9px;font:800 10.5px ' + FONT + ';color:#cfe0ff;background:rgba(74,140,255,.18);border:1px solid rgba(74,140,255,.45);white-space:nowrap}' +
  '.dh-set-src span.raid{color:#ffd9b0;background:rgba(255,120,60,.16);border-color:rgba(255,140,70,.5)}' +
  '.narrow .dh-set-grid{grid-template-columns:repeat(2,minmax(0,1fr))}' +
  '.narrow .dh-set-card{padding:7px}';

function ensureStyle(): void {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const st = document.createElement('style');
  st.id = STYLE_ID;
  st.textContent = CSS;
  document.head.appendChild(st);
}

/**
 * 세트 탭 본문. onPick(uid): 가진 부위 칸을 누르면 「장비」 탭에서 그 장비를 고른다
 */
export function renderSetPanel(body: HTMLElement, view: GameView, onPick: (uid: string) => void): void {
  ensureStyle();
  const m = setPanelModel(view.gear);
  const root = el('div', '', body);
  root.className = 'dh-set';
  root.dataset.testid = 'set-panel';
  // 맨 위: 발동 세트 수 + 착용 세트 그림 칸
  const top = el('div', '', root);
  top.className = 'dh-set-top';
  top.dataset.testid = 'set-worn';
  const cnt = el('div', '', top);
  cnt.className = 'cnt' + (m.activeCount ? '' : ' off');
  cnt.dataset.testid = 'set-active-count';
  el('b', '', cnt, String(m.activeCount));
  el('small', '', cnt, '세트 발동');
  const worn = el('div', '', top);
  worn.className = 'dh-set-worn';
  if (m.worn.length === 0) el('span', '', worn, '장착한 세트 장비가 없다').className = 'dh-set-none';
  for (const w of m.worn) {
    const ch = el('div', '', worn);
    ch.className = 'dh-set-chip' + (w.on2 ? ' on' : '');
    ch.dataset.testid = 'set-worn-chip';
    ch.title = w.name + ' ' + w.count + '/4';
    const im = el('img', '', ch) as HTMLImageElement;
    im.alt = ''; im.draggable = false; im.decoding = 'async';
    im.addEventListener('error', () => { im.style.visibility = 'hidden'; });
    im.src = assetUrl(w.icon);
    el('i', '', ch, w.count + '/4');
  }
  const grid = el('div', '', root);
  grid.className = 'dh-set-grid';
  for (const c of m.cards) card(grid, c, onPick);
}

function card(parent: HTMLElement, c: SetCardView, onPick: (uid: string) => void): void {
  const box = el('section', '', parent);
  box.className = 'dh-set-card' + (c.bonuses[1].on ? ' on2 on4' : c.bonuses[0].on ? ' on2' : '');
  box.dataset.testid = 'set-card';
  box.dataset.set = c.id;
  box.setAttribute('aria-label', c.name + ' 세트, 장착 ' + c.equipped + '/4, 보유 ' + c.owned + '/4');
  const hd = el('div', '', box);
  hd.className = 'dh-set-hd';
  const bi = el('img', '', hd) as HTMLImageElement;
  bi.alt = ''; bi.draggable = false; bi.decoding = 'async';
  bi.addEventListener('error', () => { bi.style.display = 'none'; });
  bi.src = assetUrl(BADGE_SET);
  el('b', '', hd, c.name);
  el('em', '', hd, c.equipped + '/4');
  const pcs = el('div', '', box);
  pcs.className = 'dh-set-pcs';
  for (const p of c.pieces) piece(pcs, c, p, onPick);
  const fx = el('div', '', box);
  fx.className = 'dh-set-fx';
  for (const b of c.bonuses) {
    const ln = el('div', '', fx);
    ln.className = b.on ? 'on' : '';
    ln.dataset.testid = 'set-bonus-' + b.need;
    ln.dataset.on = b.on ? '1' : '0';
    el('i', '', ln, String(b.need));
    el('span', '', ln, b.text).title = b.need + '세트: ' + b.text;
  }
  const src = el('div', '', box);
  src.className = 'dh-set-src';
  for (const s of c.sources) el('span', '', src, s).className = s.endsWith('보스') ? '' : 'raid';
}

function piece(parent: HTMLElement, c: SetCardView, p: SetPieceView, onPick: (uid: string) => void): void {
  const b = el(p.uid ? 'button' : 'div', '', parent);
  b.className = 'dh-set-pc ' + p.state;
  b.dataset.testid = 'set-piece';
  b.dataset.state = p.state;
  b.dataset.slot = p.slot;
  const label = c.name + ' ' + SLOT_KO[p.slot] + (p.state === 'equipped' ? ' · 장착 중' : p.state === 'owned' ? ' · 보유' : ' · 없음');
  b.setAttribute('aria-label', label);
  b.setAttribute('data-tip', label);
  gearImg(b, p.icon, p.fallback);
  if (p.state === 'equipped') el('span', '', b, '✓').className = 'ck';
  el('span', '', b, SLOT_KO[p.slot]).className = 'nm';
  const uid = p.uid;
  if (uid) {
    (b as HTMLButtonElement).type = 'button';
    b.dataset.focusKey = 'setpc:' + c.id + ':' + p.slot;
    b.addEventListener('click', () => onPick(uid));
  }
}
